import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftBadge from "components/SoftBadge";
import SoftButton from "components/SoftButton";



export default function TableData({data}) {

const tableMainData = {
  columns: [
    { name: "User Name", align: "left" },
    { name: "Offer Name", align: "center" },
    { name: "Offer Type", align: "center" },
    { name: "Redemption Date", align: "center" },
    { name: "Coupon Code", align: "center" },
    { name: "Location", align: "center" },
  ],
  rows: [],
};

data&&data.length>0&&data.map((row) => { 
 tableMainData.rows.push(

  {
    'User Name':(
      <SoftBox display="flex" alignItems="center" px={1} py={0.5}>
      <SoftBox display="flex" flexDirection="column">
        <SoftTypography variant="button" fontWeight="medium">
         {row?.customerUserId?.firstName}
        </SoftTypography>
        <SoftTypography variant="caption" color="info">
          {row?.customerUserId?.lastName}
        </SoftTypography>
      </SoftBox>
    </SoftBox>
    ),

    "Offer Name": (
      <SoftTypography variant="caption" fontWeight="medium">
        {row?.offerId?.name}
      </SoftTypography>
    ),
    "Offer Type": (
      <SoftTypography variant="caption" fontWeight="medium">
        {row?.offerId?.type}
      </SoftTypography>
    ),
    "Redemption Date": (
      <SoftTypography variant="caption" fontWeight="medium">
        {row?.createdAt?.slice(0, 10)}
      </SoftTypography>
    ),
    "Coupon Code": (
      <SoftTypography variant="caption" fontWeight="medium">
        {row?.coupon_code || 'N/A'}
      </SoftTypography>
    ),
    Location: (
      <SoftTypography variant="caption" fontWeight="medium">
        {row?.businessId?.locationName}
      </SoftTypography>
    ),
  },
);
});

return tableMainData;

};









